import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
import '@/filters';
import users from '@/users';
import enquiriesToolsCustDetails from '@/employee/enquiries/customerDetails/enquiriesToolsCustDetails';

enum CustomerAccountStatus {
  Active = 0,
  Closed = 1,
}

enum AccountType {
  SingleAccount = 0,
  SubAccount = 1,
  GroupAccount = 2,
}

enum CustomerGender {
  None = 0,
  Male = 1,
  Female = 2,
}

export default {
  name: 'TransSignLinkedAccPropSmsCustFields',
    components: {
      DataGridComp: require('@/customcontrols/datagrid.vue').default,
      LoadingIndicator: require('@/customcontrols/circleLoadingIndicator/circleLoadingIndicator.vue').default,
      EmptyStates: require('@/customcontrols/emptyState/emptyState.vue').default,
      CustomerCustomFields: require('@/employee/enquiries/customerCustomFields/customerCustomFields.vue').default,
      CustomerApplication: require('@/employee/enquiries/customerDetailsApplications/customerDetailsApplications.vue').default,
  },
  mixins: [users, enquiriesToolsCustDetails],
  data: function () {
    return {
      menuVisible: true, 
      lang: '',
      pagesLoaded: ['customFields', 'sms', 'linkedProperties', 'transactions', 'digitalSignature', 'portalLinks'],

      sms: {
        cols: [],
        data: [],
        totalRow: 0,
        pageingOption: { pageSize: 10, total: 0, page: 1 },
        keyCol: "",
        isLoading: true,
      },
      linkedProperties: {
        cols: [],
        data: [],
        totalRow: 0,
        pageingOption: { pageSize: 10, total: 0, page: 1 },
        keyCol: "",
        isLoading: true,
      },
      transactions: {
        cols: [],
        data: [],
        totalRow: 0,
        pageingOption: { pageSize: 10, total: 0, page: 1 },
        keyCol: "",
        isLoading: true,
      },
      digitalSignature: {
        cols: [],
        data: [],
        totalRow: 0,
        pageingOption: { pageSize: 10, total: 0, page: 1 },
        keyCol: "",
        isLoading: true,
      },
      portalLinks: {
        cols: [],
        data: [],
        totalRow: 0,
        pageingOption: { pageSize: 10, total: 0, page: 1 },
        keyCol: "",
        isLoading: true,
      },
    }
  },
  created() {
    this.selectedTab = 'portalLinks';
    this.fillGridColumns();
    this.$material.locale.dateFormat = 'dd/MM/yyyy';
  },
  mounted() {
    this.menuVisible = this.getFromLocal('_enquries_cust_det');
  },
  computed: {
    isLoading: function () {
      return this.sms.isLoading || this.linkedProperties.isLoading || this.transactions.isLoading || this.digitalSignature.isLoading || this.portalLinks.isLoading;
    },
    isRtl: function () {
      return this.lang == 'ar' ? true : false
    },
    selectedTabObj: function() {
      return this.tabs.filter(t => t.id == this.selectedTab)[0];
    },
    empName: function () {
      return this.customerDisplayInfo && this.customerDisplayInfo.stampUser ? this.customerDisplayInfo.stampUser : null;
    }
  },
  watch: {
    selectedTab: function (val) {
      if (!val)
        return;

      switch (val) {
        case 'history':
        default:
         this.$root.$emit(`refresh_data_grid:${val}DataGrid`);
          break;
      }

      this.changeUrlLink(val);
    },
  },
  methods: {
    init() {
      this.fillGridColumns();
      this.getData();
    },
    getData() {
      this.fillTransactions();
      this.fillDigitalSignature();
      this.fillPortalLinks();
      this.fillSms();
      this.fillLinkedProperties();
    },

    fillGridColumns() {
      this.portalLinks.cols.length = 0;
      this.digitalSignature.cols.length = 0;
      this.transactions.cols.length = 0;
      this.linkedProperties.cols.length = 0;
      this.sms.cols.length = 0;

      this.transactions.cols.push({ dataField: 'custkey', caption: this.$t('enquiriesCustomerDetails.custkey') });
      this.transactions.cols.push({ dataField: 'accountName', caption: this.$t('enquiriesCustomerDetails.accountName') });
      this.transactions.cols.push({ dataField: 'effectiveDate', caption: this.$t('enquiriesCustomerDetails.date'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYY });
      this.transactions.cols.push({ dataField: 'transNoAbs', caption: this.$t('enquiriesCustomerDetails.transNo') });
      this.transactions.cols.push({ dataField: 'transactionType', caption: this.$t('enquiriesCustomerDetails.type') });
      this.transactions.cols.push({ dataField: 'transactionDescription', caption: this.$t('enquiriesCustomerDetails.description') });
      this.transactions.cols.push({ dataField: 'documentNo', caption: this.$t('enquiriesCustomerDetails.documentRef') });
      this.transactions.cols.push({ dataField: 'currentReadingS', caption: this.$t('enquiriesCustomerDetails.reading') });
      this.transactions.cols.push({ dataField: 'consumption', caption: this.$t('enquiriesCustomerDetails.consumption') });
      this.transactions.cols.push({ dataField: 'debit', caption: this.$t('enquiriesCustomerDetails.debit') });
      this.transactions.cols.push({ dataField: 'credit', caption: this.$t('enquiriesCustomerDetails.credit') });
      this.transactions.cols.push({ dataField: 'vatAmountS', caption: this.$t('enquiriesCustomerDetails.vat') });
      this.transactions.cols.push({ dataField: 'balanceS', caption: this.$t('enquiriesCustomerDetails.balance') });
      this.transactions.cols.push({ dataField: 'statementNoAbs', caption: this.$t('enquiriesCustomerDetails.statementNo') });
      this.transactions.cols.push({ dataField: 'billingDate', caption: this.$t('enquiriesCustomerDetails.statementDate'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYY });
      this.transactions.cols.push({ dataField: 'propertyRef', caption: this.$t('enquiriesCustomerDetails.propertyRef') });
      this.transactions.cols.push({ dataField: 'meterRef', caption: this.$t('enquiriesCustomerDetails.meterRef') });
      this.transactions.cols.push({ dataField: 'glBatchNo', caption: this.$t('enquiriesCustomerDetails.batchNo') });
      this.transactions.cols.push({ dataField: 'consumptionTypeS', caption: this.$t('enquiriesCustomerDetails.consumptionType') });
      this.transactions.cols.push({ dataField: 'revTransNoAbs', caption: this.$t('enquiriesCustomerDetails.revTransNo') });
      this.transactions.cols.push({ dataField: 'stampUser', caption: this.$t('enquiriesCustomerDetails.stampUser') });
      this.transactions.cols.push({ dataField: 'stampDate', caption: this.$t('enquiriesCustomerDetails.stampDate'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYY });


      this.digitalSignature.cols.push({ dataField: 'sourceTypeS', caption: this.$t('enquiriesCustomerDetails.source') });
      this.digitalSignature.cols.push({ dataField: 'sourceId', caption: this.$t('enquiriesCustomerDetails.sourceId') });
      this.digitalSignature.cols.push({ dataField: 'sourceDetails', caption: this.$t('enquiriesCustomerDetails.sourceDetails') });
      this.digitalSignature.cols.push({ dataField: 'stampUser', caption: this.$t('enquiriesCustomerDetails.stampUser') });
      this.digitalSignature.cols.push({ dataField: 'stampDateTime', caption: this.$t('enquiriesCustomerDetails.stampDateTime'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYYYHHmm });
      this.digitalSignature.cols.push({ dataField: 'fileName', caption: this.$t('enquiriesCustomerDetails.fileName') });


      this.portalLinks.cols.push({ dataField: 'linkedCustkey', caption: this.$t('enquiriesCustomerDetails.custkey') });
      this.portalLinks.cols.push({ dataField: 'name', caption: this.$t('enquiriesCustomerDetails.name') });


      this.sms.cols.push({ dataField: 'smsId', caption: this.$t('enquiriesCustomerDetails.id') });
      this.sms.cols.push({ dataField: 'sourceTypeText', caption: this.$t('enquiriesCustomerDetails.sourceType') });
      this.sms.cols.push({ dataField: 'address', caption: this.$t('enquiriesCustomerDetails.address') });
      this.sms.cols.push({ dataField: 'text', caption: this.$t('enquiriesCustomerDetails.text') });
      this.sms.cols.push({ dataField: 'statusText', caption: this.$t('enquiriesCustomerDetails.status') });
      this.sms.cols.push({ dataField: 'error', caption: this.$t('enquiriesCustomerDetails.error') });
      this.sms.cols.push({ dataField: 'processedDateTime', caption: this.$t('enquiriesCustomerDetails.processed'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYYYHHmm });
      this.sms.cols.push({ dataField: 'stampUser', caption: this.$t('enquiriesCustomerDetails.stampUser') });
      this.sms.cols.push({ dataField: 'stampDateTime', caption: this.$t('enquiriesCustomerDetails.stampDateTime'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYYYHHmm });

      this.linkedProperties.cols.push({ dataField: 'ref', caption: this.$t('captureMR.propertyRef') });
      this.linkedProperties.cols.push({ dataField: 'share', caption: this.$t('enquiriesCustomerDetails.Share') });
    },

    fillTransactions(loader = true) {
      var parameters = {
        custkey: this.custkey,
        loginEmail: this.getLoginName(),
        Options: this.transactions.pageingOption
      }

      if (loader)
        this.transactions.isLoading = true;

      axios.post('/Enquiries/getCustomerTransactions', parameters)
        .then(response => {
          if (response.status == 200) {
            this.transactions.data = response.data.items;

            this.transactions.totalRow = response.data.itemsCount;
          }
        })
        .catch(e => { })
        .finally(() => this.transactions.isLoading = false);
    },

    fillDigitalSignature(loader = true) {
      var parameters = {
        custkey: this.custkey,
        loginEmail: this.getLoginName(),
        Options: this.digitalSignature.pageingOption
      }

      if (loader)
        this.digitalSignature.isLoading = true;

      axios.post('/Enquiries/getCustomerDigitalSignature', parameters)
        .then(response => {
          if (response.status == 200) {
            this.digitalSignature.data = response.data.items;

            this.digitalSignature.totalRow = response.data.itemsCount;
          }
        })
        .catch(e => { })
        .finally(() => this.digitalSignature.isLoading = false);
    },

    fillPortalLinks(loader = true) {
      var parameters = {
        custkey: this.custkey,
        loginEmail: this.getLoginName(),
        Options: this.portalLinks.pageingOption
      }

      if (loader)
        this.portalLinks.isLoading = true;

      axios.post('/Enquiries/getCustomerPortalLinks', parameters)
        .then(response => {
          if (response.status == 200) {
            this.portalLinks.data = response.data.items;

            this.portalLinks.totalRow = response.data.itemsCount;
          }
        })
        .catch(e => { })
        .finally(() => this.portalLinks.isLoading = false);
    },

    fillSms(loader = true) {
      var parameters = {
        custkey: this.custkey,
        loginEmail: this.getLoginName(),
        Options: this.sms.pageingOption
      }

      if (loader)
        this.sms.isLoading = true;

      axios.post('/Enquiries/getCustomerSms', parameters)
        .then(response => {
          if (response.status == 200) {
            this.sms.data = response.data.items;

            this.sms.totalRow = response.data.itemsCount;
          }
        })
        .catch(e => { })
        .finally(() => this.sms.isLoading = false);
    },
    
    fillLinkedProperties(loader = true) {
      var parameters = {
        custkey: this.custkey,
        loginEmail: this.getLoginName(),
        Options: this.linkedProperties.pageingOption
      }

      if (loader)
        this.linkedProperties.isLoading = true;
      axios.post('/Enquiries/getPortalRepresentedLinkedProperties', parameters)
        .then(response => {
          if (response.status == 200) {
            this.linkedProperties.data = response.data.items;

            this.linkedProperties.totalRow = response.data.itemsCount;
          }
        })
        .catch(e => { })
        .finally(() => this.linkedProperties.isLoading = false);
    },
    propertySelected(item) {
      this.openNewWindow(`/propertyDetails/${item.data.propertyId}`);
    },
  }
}

